/** @format */

export type CountryCode = 'it' | 'fr' | 'es' | 'pt';

export const CITIES_TO_COUNTRY = new Map<string, CountryCode>([
  // Italian cities
  ['Bologna', 'it'],
  ['Bologne', 'it'],
  ['Bolonia', 'it'],
  ['Cesano_boscone', 'it'],
  ['Como', 'it'],
  ['Côme', 'it'],
  ['Corsico', 'it'],
  ['Ferrara', 'it'],
  ['Ferrare', 'it'],
  ['Firenze', 'it'],
  ['Florence', 'it'],
  ['Florencia', 'it'],
  ['Milan', 'it'],
  ['Milano', 'it'],
  ['Milán', 'it'],
  ['Padova', 'it'],
  ['Padua', 'it'],
  ['Padoue', 'it'],
  ['Parma', 'it'],
  ['Parme', 'it'],
  ['Roma', 'it'],
  ['Rome', 'it'],
  ['Sesto_san_giovanni', 'it'],
  ['Siena', 'it'],
  ['Sienne', 'it'],
  ['Torino', 'it'],
  ['Turin', 'it'],
  ['Turín', 'it'],
  ['Trento', 'it'],
  ['Trente', 'it'],
  ['Trieste', 'it'],
  ['Venezia', 'it'],
  ['Venice', 'it'],
  ['Venecia', 'it'],
  ['Venise', 'it'],
  ['Vimodrone', 'it'],

  // French cities
  ['Bordeaux', 'fr'],
  ['Burdeos', 'fr'],
  ['Lille', 'fr'],
  ['Lyon', 'fr'],
  ['Lione', 'fr'],
  ['Montpellier', 'fr'],
  ['Paris', 'fr'],
  ['Parigi', 'fr'],
  ['París', 'fr'],
  ['Toulouse', 'fr'],
  ['Tolosa', 'fr'],

  // Spanish cities
  ['Madrid', 'es'],

  // Portuguese cities
  ['Lisbon', 'pt'],
  ['Lisboa', 'pt'],
  ['Lisbona', 'pt'],
  ['Lisbonne', 'pt'],
]);
